export default __webpack_public_path__ + "static/media/gallery_12.078429a2.jpeg";